import { reactive, ref } from "vue"
import BKMyOrder from "../service/BKMyOrder"
import { MyorderModel } from "../model/MyorderModel"

export default function () {
    const items = ref([])

    const events = reactive({
        onLoading: () => true,
        onLoaded: () => true,
        onSuccess: () => true,
        onError: () => true,
    })

    const getTrackingOrders = function (searchTerm) {
        items.value = []
        events.onLoading()
        BKMyOrder.apiTrackingGuestOrder(searchTerm).subscribe({
            next: (data) => {
                let arr = []
                for (const item of data) {
                    arr.push(new MyorderModel(item))
                }
                items.value = arr

                events.onLoaded()
                events.onSuccess(items)
            },
            error: (err) => {
                events.onLoaded()
                events.onError(err)
            }
        })
    }

    return {
        getTrackingOrders,
        events,
        items
    }
}
